import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, InfiniteScroll } from 'ionic-angular';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { NotificacionesProvider }  from '@providers/notificaciones/notificaciones';
import { AuthProvider }  from '@providers/auth/auth';
import * as moment from 'moment';

@IonicPage()
@Component({
  selector: 'page-notificaciones',
  templateUrl: 'notificaciones.html',
})
export class NotificacionesPage {

  campaign: any;
  jugador: any;
  equipo: any;
  notificaciones: Array<any>;
  pagina: number;

  @ViewChild(InfiniteScroll) infinityScroll: InfiniteScroll;


  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public campaignsProvider: CampaignsProvider,
    public notificacionesProvider: NotificacionesProvider,
    public authProvider: AuthProvider,
  ) {
    this.notificaciones = [];
    this.pagina = 0;
  }

  async ionViewWillEnter() {
    try {
      this.campaign = await this.campaignsProvider.get();
      this.jugador = await this.authProvider.getSession();
      this.equipo = await this.authProvider.getEquipo();

      this.getNotifications();

    } catch (error) { }
  }

  async getNotifications(refresher?: any) {
    const response = await this.notificacionesProvider.getNotifications(this.equipo.area._id, this.jugador._id, 0);
    
    this.notificaciones = response;

    if(refresher) {
      refresher.complete();
      this.infinityScroll.enabled = true;
    }
  }
  
  async getMoreNotifications(infiniteScroll) {
    this.pagina++;
    const response = await this.notificacionesProvider.getNotifications(this.equipo.area._id, this.jugador._id, this.pagina);

    if(response.length) {
      infiniteScroll.complete();
      this.notificaciones = this.notificaciones.concat(response);
    } else {
      this.pagina--;
      infiniteScroll.enable(false);
    }
    
  }

  formatTime(time) {
    const now = moment();
    const date = moment(time);

    const seconds = now.diff(date, 'second');
    
    if(seconds <= 59) {
      return `Hace ${seconds} ${seconds == 1 ? 'segundo': 'segundos' }`;
    }

    const minutes = now.diff(date, 'minutes');
    if(minutes <= 59) {
      return `Hace ${minutes} ${minutes == 1 ? 'minuto': 'minutos' }`;
    }

    const hours = now.diff(date, 'hours');
    if(hours <= 59) {
      return `Hace ${hours} ${hours == 1 ? 'hora': 'horas' }`;
    }

    const days = now.diff(date, 'days');
    if(days <= 6) {
      return `Hace ${days} ${days == 1 ? 'día': 'días' }`;
    }
    
    const months = now.diff(date, 'months');
    return `Hace ${months} ${months == 1 ? 'mes': 'meses' }`;
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/notificaciones/notificaciones.ts